import { z } from 'zod';
import { ApiPath, systemSettingSchema } from '@app/shared';
import { apiGet, apiPut } from '../../lib/api';

const systemSettingsArraySchema = z.array(systemSettingSchema);

export async function getSystemSettings() {
  return apiGet(ApiPath.SYSTEM.SETTINGS, systemSettingsArraySchema);
}

export async function updateSystemSetting(kunci: string, nilai: string | null, alasan: string) {
  return apiPut(
    `${ApiPath.SYSTEM.SETTINGS}/${encodeURIComponent(kunci)}`,
    { nilai, alasan, konfirmasi: true },
    systemSettingSchema,
  );
}
